import type { TermSummary } from '@orgus/protocol';
import { plural } from '@orgus/ui';
import type { Verdict } from '../glance/PageVerdict.tsx';

/** Terminals' one answer: how many are live, and whether a machine dropped. */
export function termsVerdict(terms: readonly Pick<TermSummary, 'state'>[]): Verdict {
  const live = terms.filter((t) => t.state === 'live' || t.state === 'starting').length;
  const off = terms.filter((t) => t.state === 'disconnected').length;
  const ended = terms.filter((t) => t.state === 'exited').length;
  if (off) return { tone: 'attention', title: `${plural(off, 'terminal')} waiting for a machine`, line: 'They resume when the machine reconnects.' };
  if (!live) return { tone: 'neutral', title: 'No terminal is live', line: ended ? `${plural(ended, 'terminal')} ended. Start a new one to keep going.` : undefined };
  return { tone: 'ok', title: `${plural(live, 'terminal')} live`, line: ended ? `${plural(ended, 'terminal')} ended` : 'Everything is connected' };
}

/** Terminal states as work states, for the one segmented bar. */
export function termStateCounts(terms: readonly Pick<TermSummary, 'state'>[]) {
  const n = (s: TermSummary['state']) => terms.filter((t) => t.state === s).length;
  return { running: n('live'), queued: n('starting'), stale: n('disconnected'), landed: n('exited') };
}
